module.exports = __webpack_public_path__ + "static/media/hero-logo.e01e37cf.svg";